import {ReactComponent as WavyLineIcon} from './wavyLine.svg'

function WavyLine() {
  return <WavyLineIcon />
}

export default WavyLine
